import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="adverts"
export default class extends Controller {
  static targets = ["dialog", "mobile", "desktop", "leaderboard", "frame"]
  static values = {
    open: Boolean,
    primary: String,
    secondary: String,
    seed: String,
  }

  accept() {
    this.insertAdverts()
    this.close()
  }

  acceptError() {
    this.insertErrorAdverts()
    this.close()
  }

  manage() {
    this.close()
  }

  insertErrorAdverts() {
    // mobile
    var el = document.createElement("script");
    el.setAttribute("src", "//www.highperformanceformat.com/eb82d8d22df7e66a73609c3ef6cfabdc/invoke.js");
    window.atOptions = {
      'key' : 'eb82d8d22df7e66a73609c3ef6cfabdc',
      'format' : 'iframe',
      'height' : 728,
      'width' : 90,
      'params' : {}
    };
    this.mobileTarget.appendChild(el);

    // leaderboard
    setTimeout(function() {
      var el = document.createElement("script");
      el.setAttribute("src", "//www.highperformanceformat.com/01d0fd6adf16821fbf845ce63425b678/invoke.js");
      window.atOptions = {
        'key' : '01d0fd6adf16821fbf845ce63425b678',
        'format' : 'iframe',
        'height' : 50,
        'width' : 320,
        'params' : {}
      };
      this.leaderboardTarget.appendChild(el);
    }.bind(this),300)

    // desktop
    setTimeout(function() {
      var el = document.createElement("script");
      el.setAttribute("src", "//www.highperformanceformat.com/6afe22bbf144254802b2a4f477912f39/invoke.js");
      window.atOptions = {
        'key' : '6afe22bbf144254802b2a4f477912f39',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
      this.desktopTarget.appendChild(el);
    }.bind(this),600)

    // social bar
    var el = document.createElement("script");
    el.setAttribute("src", "//pl25083515.profitablecpmrate.com/fb/10/b6/fb10b66bedba70fcce9523419d899e37.js");
    document.body.appendChild(el);
  }

  insertAdverts() {
    console.log(this.seedValue)
    this.frameTarget.src = `/ads/${this.seedValue}`

    // var el = document.createElement("script");
    // el.setAttribute("src", this.primaryValue);
    // document.head.appendChild(el);

    // if (this.secondaryValue) {
    //   var el2 = document.createElement("script");
    //   el2.setAttribute("src", this.secondaryValue);
    //   document.head.appendChild(el2);
    // }
  }

  connect() {
    if (this.openValue) this.open()
    this.boundBeforeCache = this.beforeCache.bind(this)
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  open() {
    this.dialogTarget.showModal()
  }

  // Allows for a closing animation since display transitions don't work yet
  close() {
    this.dialogTarget.setAttribute("closing", "")

    Promise.all(
      this.dialogTarget.getAnimations().map((animation) => animation.finished),
    ).then(() => {
      this.dialogTarget.removeAttribute("closing")
      this.dialogTarget.close()
    })
  }

  backdropClose(event) {
    if (event.target.nodeName == "DIALOG") this.close()
  }

  // For showing non-modally
  show() {
    this.dialogTarget.show()
  }

  beforeCache() {
    this.close()
  }
}
